import { render, staticRenderFns } from "./TxPresenterBuilder.vue?vue&type=template&id=862fc4ae&scoped=true"
import script from "./TxPresenterBuilder.vue?vue&type=script&lang=js"
export * from "./TxPresenterBuilder.vue?vue&type=script&lang=js"
import style0 from "./TxPresenterBuilder.vue?vue&type=style&index=0&id=862fc4ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "862fc4ae",
  null
  
)

export default component.exports